import React, { useEffect, useState } from 'react';
import { Header, Pagination, Segment } from 'semantic-ui-react';
import { connect } from 'react-redux';
import moment from 'moment';

import HireMemoPdfActionButton from './hireMemoPDFActionButton';

import TitleBar from '../titleBar/title_bar';
import AgGridTable from '../common/agGridTable';
import LoadingPlaceholder from '../placeholderComponent/loadingPlaceholder';

// import ExpenseActionButton from './expenseActionButton';

import { getHireMemo, deleteHireMemo, generateHireMemoPDF, exportHireMemo } from '../../redux/actions/hireMemoAction';

function HireMemoTable(props) {

    const { getHireMemo, hireMemoData, hireMemoLoading, generateHireMemoPDF, deleteHireMemo, hireMemoPagination, exportHireMemo } = props;
    const [dateData, setDateData] = useState()
    const [endDate, setEndDate] = useState()
    const [currentPage, setcurrentPage] = useState(1)

    useEffect(() => {
        getHireMemo(null,1)
    },[getHireMemo]);

    const handlePaginationChange = (e, { activePage }) => {
        getHireMemo(dateData ? dateData :null,activePage)
        setcurrentPage(activePage)
      }

    const headerChange = () => {
        if (localStorage.getItem('customerNumber') == 1158) {
            return "Partner"
        } else {
            return "Vendor"
        }
    }
    const exportHireMemoData = async (keys, cancelExportLoading) => {
        exportHireMemo(dateData ? dateData :null ,keys, cancelExportLoading)
    }

    // if (hireMemoLoading) {
    //     return (
    //         <React.Fragment>
    //             <TitleBar title="Hire Memo" LinkName="" />
    //             <LoadingPlaceholder />
    //         </React.Fragment>
    //     )

    // } else {

        let columnDefs = [
            { headerName: 'Hire Memo No.', field: 'hireMemoNo', tooltipField: 'hireMemoNo', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Hire Memo Date', field: 'hireMemoDate', tooltipField: 'hireMemoDate', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: `${headerChange()} Code`, field: 'vendorCode', tooltipField: 'vendorCode', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: `${headerChange()} Name`, field: 'vendorName', tooltipField: 'vendorName', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Vehicle No', field: 'vehicleNo', tooltipField: 'vehicleNo', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Vehicle Type', field: 'vehicleType', tooltipField: 'vehicleType', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'From City', field: 'fromCity', tooltipField: 'fromCity', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'To City', field: 'toCity', tooltipField: 'toCity', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Hire Charge', field: 'hireCharge', tooltipField: 'hireCharge', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'TDS Charges', field: 'tdsCharges', tooltipField: 'tdsCharges', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Advance Given', field: 'advanceGiven', tooltipField: 'advanceGiven', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'PDF', field: 'view', cellRenderer: 'actionRenderer', width: 80, suppressToolPanel: true, pinned: 'right' }
        ]

        let frameworkComponents = {
            actionRenderer: HireMemoPdfActionButton,
        }

        let rowData = []

        hireMemoData && hireMemoData.forEach((object, index) => {
            let temp = {}
            temp.hireMemoNo = object.hireMemoNo
            temp.hireMemoDate = object.hireMemoDate
            temp.vendorCode = object.vendorDetails.vendorCode
            temp.vendorName = object.vendorDetails.vendorName
            temp.vehicleNo = object?.vehicleDetails?.vehicleNo || "NA"
            temp.vehicleType = object.vehicleTypeDetails.vehicleType
            temp.fromCity = object.fromCityDetails.cityName
            temp.toCity = object.toCityDetails.cityName
            temp.hireCharge = object.hireCharge
            temp.tdsCharges = object.tdsCharge
            temp.advanceGiven = object.advanceGiven
            temp.generateHireMemoPDF = generateHireMemoPDF
            //Extras
            temp.hireMemoId = object.id

            rowData[index] = temp
        })

        const propsFromChild = (values) => {
            if ((values.startDate && values.endDate) || values.transporterId || values.vehicleId) {
                setDateData(values)
                setEndDate(values.endDate)
                getHireMemo(values,1)
              }
        }

        const searchHirememo= (searchTerm) =>{
            if(searchTerm){
                getHireMemo({hireMemoNo : searchTerm},1)
            }
        }

        return (
            <React.Fragment>
                <AgGridTable
                    columnDefs={columnDefs}
                    rowData={rowData}
                    pagination={false}
                    searchValue={props.searchValue}
                    link="#"
                    baseUrl={props}
                    hiddenNew={true}
                    newPopup={props.newPopup}
                    hiddenImportPopupBtn={false}
                    extraComponents={frameworkComponents}
                    titleBarTitle="Hire Memo"
                    handleSearch={props.handleSearch}
                    propsFromChild={propsFromChild}
                    exporDatatFunction={exportHireMemoData}
                    customSearch={searchHirememo}
                    isLoading={hireMemoLoading}
                />
                <Pagination
                    defaultActivePage={currentPage || hireMemoPagination?.currentPage}
                    firstItem={null}
                    lastItem={null}
                    onPageChange={handlePaginationChange}
                    pointing
                    secondary
                    totalPages={hireMemoPagination?.totalPages}
                />
            </React.Fragment>
        )
    // }
}


const mapStatetoProps = (state) => {
    return ({
        hireMemoData: state.getHireMemoReducer.hireMemo.data,
        hireMemoPagination: state.getHireMemoReducer.hireMemo.pagination,
        hireMemoLoading: state.getHireMemoReducer.isLoading
    })
}

export default connect(mapStatetoProps, { getHireMemo, deleteHireMemo, generateHireMemoPDF, exportHireMemo })(HireMemoTable)